import React, { useEffect, useMemo, useReducer, useState } from 'react';
//** Utilities */
import { Application } from 'src/config/const/enums';
//** Page Config */
import { contactCenterPages } from 'src/config/pageInfo/contactCenterPages';
// import { contactCenterPages_v2 } from 'src/config/pageInfo/contactCenterPages';
import { onlinePages } from 'src/config/pageInfo/onlinePages';
//** Page order */
import { pageOrder, pageOrderCC } from 'src/config/pageInfo/pageOrder.ts';
//** Version */
// import { useAppVersion } from 'src/versioning/VersionContext';

//** Page Context */
import PreQualificationPagesContext from './preQualificationPagesContext.jsx';
import PreQualificationPagesReducer from './preQualificationPagesReducer.jsx';
import * as types from './types';

const PreQualificationPagesState = (props) => {
  const [applicationType, setApplicationType] = useState(null);
  const [startCurrentPage, setStartCurrentPage] = useState(null);
  console.log('🚀 ~ PreQualificationPagesState ~ startCurrentPage:', startCurrentPage);
  const [pages, setPages] = useState(null);
  const [initialized, setInitialized] = useState(false);

  //? ----------------------------------------------------------------
  // let version = useAppVersion();

  //* Set the page order

  //* Set the page config
  // const pageConfigPagesOnline = useMemo(
  //   () => (version === 'v1' ? onlinePages : onlinePages_v2),
  //   [version],
  // );
  // const pageConfigPagesContactCenter = useMemo(
  //   () => (version === 'v1' ? contactCenterPages : contactCenterPages_v2),
  //   [version],
  // );

  const pageOrderOnline = pageOrder;
  const pageOrderContactCenter = pageOrderCC;
  const pageConfigPagesOnline = onlinePages;
  const pageConfigPagesContactCenter = contactCenterPages;
  //? ----------------------------------------------------------------

  //** The current valid page */
  const initialState = {
    pages: pages,
    currentPageIndex: 0,
    currentPage: startCurrentPage,
    nextPage: null,
    previousPage: null,
    lastValidPageIndex: 0,
    isFirstPage: true,
    isLastPage: false,
    isPopLastNavType: false,
    application: null,
  };

  const [state, dispatch] = useReducer(PreQualificationPagesReducer, initialState);

  function getPageByIndex(pageIndex) {
    //** FIND PAGE BY PAGE INDEX */
    const pageByIndex = state?.pages?.find((obj) => {
      return obj.index === pageIndex;
    });

    return pageByIndex;
  }
  //----------------------------------------------------------------
  //** Startup */
  //? Put anything in here that needs to happen before we show the
  //? first page.
  const initializing = async (application) => {
    //* Set the application type (Online, ContactCenter)
    //* on first load.
    setApplicationType(application);
  };

  //* Sort the pages by the page index before
  //* storing locally
  const sortPages = (pagesUnsorted) => {
    if (pagesUnsorted?.length <= 0) return;
    let sortedPages = pagesUnsorted?.sort((p1, p2) =>
      p1.index > p2.index ? 1 : p1.index < p2.index ? -1 : 0,
    );

    return sortedPages;
  };

  useEffect(() => {
    switch (applicationType) {
      case Application.ONLINE: {
        const onlinePagesSort = sortPages(pageConfigPagesOnline());
        setPages(onlinePagesSort);

        break;
      }
      case Application.CONTACT_CENTER: {
        const contactCenterPagesSort = sortPages(pageConfigPagesContactCenter());
        setPages(contactCenterPagesSort);

        break;
      }
      default:
        setPages(null);
        break;
    }
  }, [applicationType, pageConfigPagesContactCenter, pageConfigPagesOnline]);

  useEffect(() => {
    if (pages) {
      // when retrieve happens check the sessionStorage and redirect the user to the loading page
      const isRetrieveFlag = sessionStorage.getItem('retrieveQuoteJourney');
      if (isRetrieveFlag) {
        setStartCurrentPage(
          pages[
            applicationType === Application.ONLINE
              ? pageOrderOnline.RETRIEVE_QUOTE_LOADING
              : pageOrderContactCenter.RETRIEVE_QUOTE_LOADING
          ],
        );
        sessionStorage.removeItem('retrieveQuoteJourney');
      } else {
        setStartCurrentPage(pages[0]); //* Set the page to the first in the page object after the sort.
      }
      setInitialized(true);
    }
  }, [
    pages,
    applicationType,
    pageOrderOnline.RETRIEVE_QUOTE_LOADING,
    pageOrderContactCenter.RETRIEVE_QUOTE_LOADING,
  ]);

  useEffect(() => {
    const payload = {
      pages: pages,
      currentPage: startCurrentPage,
      currentPageIndex: 0,
      lastValidPageIndex: 0,
      isFirstPage: true,
      isLastPage: false,
      isPopLastNavType: false,
      application: applicationType,
    };
    //** Update the state on first load*/
    dispatch({ type: types.UPDATE_PAGE_VALID, payload: payload });
  }, [applicationType, pages, startCurrentPage]);
  //----------------------------------------------------------------

  //** The items to be displayed in the Progress bar */
  // const progressItems = [
  //   'Your Details',
  //   'Select Cover',
  //   'About You',
  //   'Review Application',
  //   'Review & Purchase',
  // ];

  const progressItems = [
    'Get Started',
    'Select Cover',
    'Provisional Quote',
    'About You',
    'Review Application',
    'Application Outcome',
    'Contact Details & Purchase',
  ];

  //** Set the Page validity on 'NEXT' button click */
  //** This gets called "FIRST". This is followed */
  //** by a call to  getRequestPage */
  const validateAndProceed = async (pageIndex, stayOnCurrentPage = false) => {
    // if (pageIndex === 'undefined' || pageIndex === state.currentPageIndex) return;

    if (pageIndex === 'undefined') return;
    try {
      const currentIndex = pageIndex ? pageIndex : state.currentPageIndex;
      const currentPage = getPageByIndex(currentIndex);

      //* We're moving off this page so, make it valid.
      currentPage.valid = true;

      //* Update the pages object
      pages[currentIndex] = {
        ...pages[currentIndex],
        ...currentPage,
      };

      const pageCount = pages.length - 1;

      //* Now, we want to get the request page, the next page after the requested page (if there is one)
      //* and the previous page before the requested page (if there is one)

      //? Requested Page
      const requestedIndex =
        stayOnCurrentPage === true || currentIndex + 1 > pageCount
          ? currentIndex
          : currentIndex + 1;

      const lastValidPageIndex = stayOnCurrentPage === true ? currentIndex - 1 : currentIndex;
      //* On some pages we don't want to move to the next page
      //* for example, on the decline page, we want to ensure that the user
      //* can not move to another page
      const requestedPage = getPageByIndex(
        stayOnCurrentPage === false ? requestedIndex : currentIndex,
      );

      const payload = {
        pages: pages,
        currentPage: requestedPage,
        currentPageIndex: requestedIndex,
        lastValidPageIndex: lastValidPageIndex,
        isFirstPage: requestedIndex === 0 ? true : false,
        isLastPage: requestedIndex === pageCount ? true : false,
        isPopLastNavType: false,
        application: applicationType,
      };
      //** Update the state */
      dispatch({ type: types.UPDATE_PAGE_VALID, payload: payload });
    } catch (ex) {
      console.error(ex);
    }
  };

  const validateOnBack = async (pageIndex, editPage = false) => {
    try {
      const currentIndex = pageIndex ? pageIndex : state.currentPageIndex;
      const currentPage = getPageByIndex(currentIndex);

      //* Update the pages object
      pages[currentIndex] = {
        ...pages[currentIndex],
        ...currentPage,
      };

      const pageCount = pages.length - 1;

      //   //? Requested Page
      const requestedIndex =
        editPage === true ? 0 : currentIndex - 1 >= 0 ? currentIndex - 1 : currentIndex;

      const requestedPage = getPageByIndex(requestedIndex);

      const payload = {
        pages: pages,
        currentPage: requestedPage,
        currentPageIndex: requestedIndex,
        lastValidPageIndex: requestedIndex + 1,
        isFirstPage: requestedIndex === 0 ? true : false,
        isLastPage: requestedIndex === pageCount ? true : false,
        isPopLastNavType: true,
        application: applicationType,
      };

      //** Update the state */
      dispatch({ type: types.UPDATE_PAGE_VALID, payload: payload });

      console.log('🚀 ~ validateOnBack ~ currentPage:', currentPage);
      return currentPage;
    } catch (ex) {
      console.error(ex);
    }
  };

  const confirmPageIndicatorSet = async (pageIndex) => {
    try {
      const currentIndex = pageIndex ? pageIndex : state.currentPageIndex;
      const currentPage = getPageByIndex(currentIndex);

      currentPage.pageIndicator = 'SET - ' + currentPage.pageIndicator;

      //* Update the pages object
      pages[currentIndex] = {
        ...pages[currentIndex],
        ...currentPage,
      };
    } catch (ex) {
      console.error(ex);
    }
  };

  const getStartPage = () => {
    try {
      const response = {
        allowPageRequest: false,
        responsePage: getPageByIndex(0),
        isBack: false,
      };
      validateOnBack(0);
      response.allowPageRequest = true;
      response.isBack = true;
      response.responsePage = state.currentPage;
      return response;
    } catch (ex) {
      console.error(ex);
    }
  };

  const getRequestPage = async ({ requestPageIndex, navType }) => {
    //** Get the Requested Page - The page the user is trying to access.  */
    //** Gets called on Next or Back */
    //** The requested may or may not be 'valid' */
    //** if it is NOT valid  */
    try {
      const response = {
        allowPageRequest: false,
        responsePage: getPageByIndex(0),
        isBack: false,
      };

      //** Has the user used the  browser back button */
      if (navType === 'POP' && state.isPopLastNavType === false) {
        const requestedBackPage = await validateOnBack();
        response.isBack = true;
        response.responsePage = requestedBackPage;
        return response;
      }

      const requestedPage = getPageByIndex(requestPageIndex);

      if (requestedPage) {
        response.allowPageRequest = true;
        response.isBack = false;
        response.responsePage = requestedPage;
        return response;
      }
      return response;
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <PreQualificationPagesContext.Provider
      value={{
        state,
        initializing,
        initialized: initialized,
        progressItems: progressItems,
        currentPage: state.currentPage,
        currentIndex: state.currentIndex,
        funcs: {
          validateAndProceed,
          validateOnBack,
          getRequestPage,
          getStartPage,
          confirmPageIndicatorSet,
        },
      }}
    >
      {props.children}
    </PreQualificationPagesContext.Provider>
  );
};

export default PreQualificationPagesState;
